var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ButtonIcon lxn-cursor-pointer",class:[_vm.roundClass, _vm.activeClass],style:(_vm.buttonStyle),on:{"mousedown":function($event){return _vm.handleMouseDown()},"mouseup":function($event){return _vm.handleMouseUp()}}},[_c('div',{staticClass:"ButtonIcon-d0 lxn-w100 lxn-h100",domProps:{"innerHTML":_vm._s(_vm.svgIcon)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }